// extracted by mini-css-extract-plugin
export default {"header":"header_header__mmJht","header_mobile":"header_header_mobile__QGoeC","nav_img":"header_nav_img__fwPP6","download_btn":"header_download_btn__JsIjS"};